import { useEffect, useState } from "react";

type ImageStatus = "loading" | "loaded" | "failed";

export const useImage = (
  url: string,
  crossOrigin: boolean = false,
  retryOnFailure: boolean = false,
): [HTMLImageElement | undefined, ImageStatus] => {
  const [status, setStatus] = useState<ImageStatus>("loading");
  const [image, setImage] = useState<HTMLImageElement | undefined>(undefined);
  useEffect(() => {
    if (!url) {
      return;
    }
    const img = new Image();
    if (crossOrigin) {
      img.crossOrigin = "Anonymous";
    }
    img.addEventListener("load", () => {
      setStatus("loaded");
    });
    img.addEventListener("error", () => {
      if (retryOnFailure) {
        setImage(undefined);
        setStatus("loading");
        return;
      }
      setStatus("failed");
    });
    img.src = url;
    setStatus("loading");
    setImage(img);
  }, [url, crossOrigin, retryOnFailure]);
  return [image, status];
};
